import { Fragment } from 'react';
import { NsContent } from '@britishgasenergy/react-nucleus/dist';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsList } from 'components/common/ns-list/NsList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';

export const testId = 'aboutSolarTestId';

export const AboutSolar = () => {
  const switchCaveatId = 'swtichCaveat';

  return (
    <>
      <NsPanel testId={testId}>
        <NsContent>
          <h2>How does the add-on work?</h2>
          <p>
            You&apos;ll get up to 25% off your electricity use for 12 months.
            Once you&apos;ve signed up, we&apos;ll add it to your current tariff
            and you&apos;ll receive your discount in every bill.
          </p>
        </NsContent>
        <NsColumn hockeypitch="2">
          <NsContent>
            <h3>How we work out your discount</h3>
            <p>
              We will use your smart meter readings to calculate your
              electricity usage during your billing period, if for any reason we
              are unable to retrieve your smart meter data to calculate your
              consumption, for example, if your meter stops sending us readings
              we may have to estimate your consumption and therefore payment.
            </p>
          </NsContent>

          <NsContent>
            <h3>How we apply your discount</h3>
            <NsList>
              {[
                `The 25% discount applies to your tariff unit rate only. You will continue to pay the full daily standing charge as per your tariff.`,
                `We’ll add the discount as a credit to your statement as per your normal billing cycle.`,
                `If you are on a time-of-use tariff, you will receive the 25% discount on the peak rate only.`
              ]}
            </NsList>
          </NsContent>
        </NsColumn>
      </NsPanel>

      <NsPanel>
        <NsContent>
          <h2>How do I sign up?</h2>
        </NsContent>
        <NsColumn hockeypitch="2">
          <NsContent>
            <h3>
              To sign up for our free Hive Solar Saver add-on you&apos;ll need
            </h3>
            <NsList>
              {[
                <Fragment key={0}>
                  A Hive solar and/or battery installation.
                  <NsCaveatLink>
                    Hive Solar Saver offer is available to customers who accept
                    a quote for a Hive solar and/or battery installation from
                    the 22nd May 2024. The offer is subject to availability and
                    can be removed at any time. We will give at least one
                    months&apos; advance notice of the offer ending on our
                    website. To be eligible for the offer, installation must be
                    completed within three months of the customer&apos;s
                    acceptance of the quote and customers must sign up for Hive
                    Solar Saver within two weeks of receiving their invitation
                    email. The 25% discount applies for twelve months from
                    sign-up to Hive Solar Saver.
                  </NsCaveatLink>
                </Fragment>,
                <Fragment key={1}>
                  To be a British Gas customer on our new system,
                  <NsCaveatLink caveatId={switchCaveatId}>
                    You’ll need to switch to a tariff on our new system and have
                    signed up to this offer within two weeks of receiving your
                    invitation email.
                  </NsCaveatLink>{' '}
                  with a supply to the same address as your solar or battery.
                </Fragment>,
                `Have a smart meter or agree to switch to one.`,
                `An invitation from us to apply for the add-on.`,
                `To pay for your energy by Direct Debit.`
              ]}
            </NsList>
          </NsContent>

          <NsContent spacing="">
            <h3>Not a British Gas customer yet?</h3>
            <p>
              You can only enjoy this add-on if you get your electricity from
              British Gas. <NsCaveatLink caveatId={switchCaveatId} /> If
              you&apos;re not with us yet, it&apos;s easy to switch.
            </p>
            <br />
            <NsSecondaryCta href={process.env.VITE_PATH_PREFIX} target="_self">
              Get a quote
            </NsSecondaryCta>
            <p>
              <b>
                Don&apos;t forget to bookmark this page to complete your
                registration for this add on, once you join us.
              </b>
            </p>
          </NsContent>
        </NsColumn>
      </NsPanel>
    </>
  );
};
